export default "__VITE_ASSET__OU59HwyB__"